import {connect} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {getAllVerifyResponse} from "../store/logIn";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import {deleteWorker, getWorkers, messageReset} from "../store/workers";
import Button from "@mui/material/Button";
import {format} from "date-fns";
import Header from "../blocks/header";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import Box from "@mui/material/Box";
import Dashboard from "../blocks/dashboard";
import Copyright from "../blocks/copyright";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import AdminFilter from "../blocks/AdminFilter";
import DeleteWorker from "../blocks/deleteWorker";
import axios from "axios";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import SearchIcon from '@mui/icons-material/Search';
import {FormControl, InputAdornment, InputLabel, OutlinedInput, Pagination} from "@mui/material";

const PAGE_SIZE = 20

function Workers(props) {
    const is_main = JSON.parse(localStorage.getItem('is_main'));
    const navigate = useNavigate()
    const params = useParams()
    const regionId = params.id || false
    const {t} = useTranslation()

    const [open, setOpen] = useState(false)
    const [openItem, setOpenItem] = useState(false)
    const [searchCompany, setSearchCompany] = useState('')
    const [searchPassport, setSearchPassport] = useState('')
    const [page, setPage] = useState(1)
    const [adminRegionId, setAdminRegionId] = useState('')
    const [searchTimer, setSearchTimer] = useState(null)

    function fetchData(pg, sc, sp, rid) {
        const _page = pg  !== undefined ? pg  : page
        const _sc   = sc  !== undefined ? sc  : searchCompany
        const _sp   = sp  !== undefined ? sp  : searchPassport
        const _rid  = rid !== undefined ? rid : (regionId || adminRegionId || '')
        props.getWorkers(_page, PAGE_SIZE, _sc, _sp, _rid, '', '')
    }

    function handleAdminFilter({regionId: r}) {
        const rid = r || ''
        setAdminRegionId(rid); setPage(1)
        props.getWorkers(1, PAGE_SIZE, searchCompany, searchPassport, rid, '', '')
    }

    useEffect(() => {
        const token = localStorage.getItem('token')
        if (token !== 'undefined') {
            props.getAllVerifyResponse({"token": JSON.parse(token)})
        }
        fetchData(1, '', '')
    }, [])

    useEffect(() => {
        if (props.verify === false) navigate("/login/")
    }, [props.verify])

    useEffect(() => {
        if (searchTimer) clearTimeout(searchTimer)
        const timer = setTimeout(() => {
            setPage(1); fetchData(1, searchCompany, searchPassport)
        }, 400)
        setSearchTimer(timer)
    }, [searchCompany, searchPassport])

    useEffect(() => {
        if (props.message === 'deleted') {
            toast.success(t('delete_success'), {theme: 'colored'})
            setOpenItem(false); props.messageReset(); fetchData()
        } else if (props.message === 'error') {
            toast.error(t('save_error'), {theme: 'colored'}); props.messageReset()
        } else if (props.message === true) {
            toast.success(t('save_success'), {theme: 'colored'}); props.messageReset()
        }
    }, [props.message])

    function handlePageChange(e, value) {
        setPage(value); fetchData(value)
        window.scrollTo({top: 0, behavior: 'smooth'})
    }

    function saveFile() {
        // Tanlangan korxona bo'lsa - faqat o'sha korxona excelini yukla
        const targetId = regionId || adminRegionId || 'all'
        const url = `https://ishlabchiqarish.uzkoj.uz/api/get-worker-excel/${targetId}`
        axios({url, method: 'GET', responseType: 'blob'}).then((response) => {
            const href = URL.createObjectURL(response.data)
            const link = document.createElement('a')
            link.href = href
            link.setAttribute('download', `ishchilar_${Date.now()}.xlsx`)
            document.body.appendChild(link); link.click()
            document.body.removeChild(link); URL.revokeObjectURL(href)
        })
    }

    function groupByCompany(workersList) {
        const groups = {}
        workersList.forEach(worker => {
            const name = worker.user?.user_name || "Noma'lum"
            if (!groups[name]) groups[name] = []
            groups[name].push(worker)
        })
        return groups
    }

    const workers = props.workers || []
    const isFiltered = searchCompany.trim() || searchPassport.trim() || regionId

    function TableHead({showCompany}) {
        return (
            <thead><tr>
                <th>#</th>
                {showCompany && <th>{t('title_company')}</th>}
                <th>{t('fullname')}</th>
                <th>{t('birth_date')}</th>
                <th>{t('passport_series')}</th>
                <th>{t('order_number')}</th>
                <th>{t('order_date')}</th>
                <th>{t('order_worktime')}</th>
                <th>{t('job')}</th>
                <th>{t('group')}</th>
                {!is_main && <th/>}
            </tr></thead>
        )
    }

    function WorkerRow({item, index, showCompany}) {
        return (
            <tr key={item.id}>
                <th>{index + 1}</th>
                {showCompany && <td>{item.user?.user_name || '-'}</td>}
                <td>{item.fullname}</td>
                <td>{format(new Date(item.birth_date), 'dd/MM/yyyy')}</td>
                <td>{item.passport_series || '-'}</td>
                <td>{item.order_number}</td>
                <td>{format(new Date(item.order_date), 'dd/MM/yyyy')}</td>
                <td>{item.order_worktime}</td>
                <td>{item.job}</td>
                <td>{item.group === 4 ? t('no_group') : item.group}</td>
                {!is_main && (
                    <td>
                        <Button variant="contained" color="info" endIcon={<EditIcon/>}
                                onClick={() => navigate('/edit-worker/' + item.id)}/>
                        <Button variant="contained" color="error" endIcon={<DeleteIcon/>}
                                onClick={() => { setOpenItem(item); setOpen(true) }}/>
                    </td>
                )}
            </tr>
        )
    }

    return <div>
        <div className={'page'}>
            {open ? <DeleteWorker setOpenItem={setOpenItem} openItem={openItem} open={open} setOpen={setOpen}/> : ''}
            <Header/>
            <Dashboard/>
            <Box component="main" sx={{flexGrow:1, height:'100vh', overflow:'auto'}}>
                <Toolbar/>
                <div className={'main'}>
                    <Button variant="outlined" startIcon={<ChevronLeftIcon/>} onClick={() => navigate(-1)}>
                        {t('back')}
                    </Button>
                    <div className={'worker-page'}>
                        <div className={'header-page'}>
                            <h2 className={'page-title'}>{t('list_employees')}</h2>
                            {!is_main && (
                                <Button variant="contained" endIcon={<AddIcon/>} onClick={() => navigate('/add-worker/')}>
                                    {t('add')}
                                </Button>
                            )}
                        </div>

                        <div style={{display:'flex', gap:'16px', marginBottom:'16px', flexWrap:'wrap'}}>
                            {is_main && !regionId && (
                                <FormControl variant="outlined" style={{minWidth:280}}>
                                    <InputLabel htmlFor="search-company">{t('search_company')}</InputLabel>
                                    <OutlinedInput
                                        id="search-company" value={searchCompany}
                                        onChange={(e) => setSearchCompany(e.target.value)}
                                        endAdornment={<InputAdornment position="end"><SearchIcon/></InputAdornment>}
                                        label={t('search_company')}/>
                                </FormControl>
                            )}
                            <FormControl variant="outlined" style={{minWidth:280}}>
                                <InputLabel htmlFor="search-passport">{t('search_passport')}</InputLabel>
                                <OutlinedInput
                                    id="search-passport" value={searchPassport}
                                    onChange={(e) => setSearchPassport(e.target.value)}
                                    endAdornment={<InputAdornment position="end"><SearchIcon/></InputAdornment>}
                                    label={t('search_passport')}/>
                            </FormControl>
                        </div>

                        {is_main && !regionId && <AdminFilter onFilter={handleAdminFilter}/>}

                        {workers.length > 0 ? (
                            is_main && !isFiltered ? (
                                Object.entries(groupByCompany(workers)).map(([companyName, companyWorkers]) => (
                                    <div key={companyName} style={{marginBottom:'32px'}}>
                                        <h4 style={{background:'#1F4E79', color:'white', padding:'8px 16px', borderRadius:'4px', marginBottom:'8px'}}>
                                            {companyName}
                                            <span style={{fontSize:'0.85em', fontWeight:'normal', marginLeft:'8px'}}>
                                                ({companyWorkers.length} {t('workers_count')})
                                            </span>
                                        </h4>
                                        <table className="table table-bordered">
                                            <TableHead showCompany={false}/>
                                            <tbody>
                                            {companyWorkers.map((item, index) => (
                                                <WorkerRow key={item.id} item={item} index={index} showCompany={false}/>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ))
                            ) : (
                                <table className="table table-bordered">
                                    <TableHead showCompany={is_main}/>
                                    <tbody>
                                    {workers.map((item, index) => (
                                        <WorkerRow key={item.id} item={item}
                                                   index={(page-1)*PAGE_SIZE + index}
                                                   showCompany={is_main}/>
                                    ))}
                                    </tbody>
                                </table>
                            )
                        ) : (
                            <div className={'no-infos'}>{t('no_info')}</div>
                        )}

                        {is_main && workers.length > 0 && (
                            <Button onClick={saveFile} variant="contained" color="primary" style={{marginTop:'8px'}}>
                                {t('download')}
                            </Button>
                        )}

                        {props.total_pages > 1 && (
                            <div style={{display:'flex', justifyContent:'center', padding:'20px 0'}}>
                                <Pagination count={props.total_pages} page={page}
                                            onChange={handlePageChange} color="primary" shape="rounded"/>
                            </div>
                        )}
                    </div>
                </div>
                <Copyright/>
            </Box>
        </div>
    </div>
}

export default connect(props => props.worker, {
    getWorkers, deleteWorker, getAllVerifyResponse, messageReset
})(Workers)